import { __ } from '@wordpress/i18n';
import { useContext } from 'react';
import SettingsScreenContext from '../../../Context/SettingsScreenContext';

import InstallSnippetLibrary from './CodeSnippets/InstallSnippetLibrary';
import WPCodeSnippet from './CodeSnippets/WPCodeSnippet';
import './CodeSnippets/CodeSnippets.css';

const ManageWPCodeIntegration = () => {
    const {
        sbCustomizer,
        editorNotification,
        editorTopLoader
    } = useContext(SettingsScreenContext);

    const wpCodeSnippets = sbCustomizer?.wpCode.snippets || [];
    const showSnippets = (sbCustomizer?.wpCode?.pluginInstalled && sbCustomizer?.wpCode?.pluginActive) || false;

    return (
        <div className='sb-wpcode-snippets'>

            {!showSnippets &&
                <InstallSnippetLibrary
                    sbCustomizer={sbCustomizer}
                    editorNotification={editorNotification}
                    editorTopLoader={editorTopLoader}
                />
            }

            {showSnippets &&
                <div className='snippet-card-grid'>
                    {wpCodeSnippets.length === 0 && (
                        <div className='snippet-card-content'>
                            <div className='snippet-card-title'>
                                {__('No snippets found', 'sb-customizer')}
                            </div>
                        </div>
                    )}

                    {wpCodeSnippets?.map((snippet, index) => {
                        return (
                            <WPCodeSnippet
                                key={index}
                                snippet={snippet}
                            />
                        );
                    })}
                </div>
            }
        </div>
    );
}

export default ManageWPCodeIntegration;